var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector44(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93827 0.625994C4.93813 0.791887 4.87213 0.950932 4.75478 1.06816L1.55542 4.26846C1.45858 4.36531 1.38176 4.48028 1.32935 4.60682C1.27694 4.73337 1.24996 4.869 1.24996 5.00597C1.24996 5.14294 1.27694 5.27857 1.32935 5.40511C1.38176 5.53166 1.45858 5.64663 1.55542 5.74347L4.75061 8.9396C4.86456 9.05761 4.92761 9.21567 4.92618 9.37973C4.92476 9.54379 4.85897 9.70072 4.74299 9.81673C4.62702 9.93274 4.47013 9.99855 4.30611 9.99998C4.1421 10.0014 3.98409 9.93833 3.86612 9.82436L0.670918 6.63073C0.241291 6.20013 0 5.61662 0 5.00826C0 4.3999 0.241291 3.81639 0.670918 3.3858L3.87029 0.183409C3.95777 0.0958441 4.06925 0.0362053 4.19063 0.0120387C4.31201 -0.012128 4.43783 0.000263628 4.55216 0.0476455C4.6665 0.0950275 4.76421 0.17527 4.83294 0.27822C4.90167 0.38117 4.93833 0.502199 4.93827 0.625994Z",
    fill: "#F26639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector44);
export default __webpack_public_path__ + "static/media/Vector (44).9058a7f14e0d4fec445fa1641a16374b.svg";
export { ForwardRef as ReactComponent };